var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 208.84",
    id: 1269473142,
    className: "svg u_1269473142",
    "data-icon-custom": "true",
    "data-icon-name": "CALIDAD.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#003F71",
    d: "M144,77.15a.74.74,0,0,1,0-.51L150,60.21a.81.81,0,0,0-.18-.8L137.34,47.17a.69.69,0,0,1-.22-.46l-1.84-17.37a.75.75,0,0,0-.5-.63l-16.54-5.64a.72.72,0,0,1-.39-.32L108.68,7.89a.76.76,0,0,0-.73-.36L90.62,9.63a.71.71,0,0,1-.49-.12L75.4.12a.73.73,0,0,0-.8,0L59.87,9.52a.76.76,0,0,1-.49.11L42.05,7.54a.74.74,0,0,0-.73.35L32.16,22.75a.78.78,0,0,1-.4.32L15.22,28.71a.75.75,0,0,0-.5.63L12.89,46.71a.75.75,0,0,1-.23.46L.22,59.42a.78.78,0,0,0-.18.79L6,76.64a.74.74,0,0,1,0,.51L0,93.59a.78.78,0,0,0,.18.79l12.44,12.25a.67.67,0,0,1,.22.46l1.84,17.36a.76.76,0,0,0,.5.64l16.54,5.64a.7.7,0,0,1,.39.31l9.17,14.87a.74.74,0,0,0,.73.35l17.33-2.09a.76.76,0,0,1,.49.11l14.73,9.4a.73.73,0,0,0,.8,0l14.73-9.4a.76.76,0,0,1,.49-.11L108,146.26a.74.74,0,0,0,.73-.35L117.84,131a.76.76,0,0,1,.4-.31l16.54-5.64a.76.76,0,0,0,.5-.64l1.83-17.36a.73.73,0,0,1,.23-.46l12.44-12.25a.78.78,0,0,0,.18-.79ZM127.74,80A52.83,52.83,0,0,1,22.17,76.9h0A52.89,52.89,0,0,1,71.91,24.16C104.07,22.3,129.6,47.83,127.74,80Z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#003F71",
    cx: 75,
    cy: 76.9,
    r: 40.58,
    transform: "translate(-15.66 19.29) rotate(-13.28)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#003F71",
    points: "35.25 159.42 23.89 140.99 20.03 139.67 3.37 191.74 33.36 190.09 56.83 208.84 70.63 165.69 56.75 156.83 35.25 159.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#003F71",
    points: "126.11 140.99 114.75 159.42 93.25 156.83 79.37 165.69 93.17 208.84 116.64 190.09 146.63 191.74 129.97 139.67 126.11 140.99"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.efd32439ab403d180ab4ed112fb05c2d.svg";
export { ForwardRef as ReactComponent };